export type LookupEntity = {
  name: string;
} & Entity;

export type UserLookupEntity = {
  email: Nullable<string>;
} & LookupEntity;

export enum LookupEntity$Type {
  LOCAL = '_local_',

  USERS = 'user',
  GROUPS = 'group',
  TAGS = 'tag',
}
